import React from 'react'

const Showrules = () => {
  return (
    <div>
        <div class="text-center ">
             <div className='rules'>
                <h1>How to play dice game</h1>
                <p>select any number</p>
                <p>Click on dice image</p>
                <p>after click  if selected number is equal to dice number you will ge the selected number point . if you get wrong
                    guess then 2 point will be deducted.
    
                </p>
                </div>
            </div>
    </div>
  )
}

export default Showrules;